export interface PosError {
    icon: string;
    range: 'bet' | 'platform' | 'pick' | 'betslip';
    code: string;
    lock?: number;
    odds?: boolean;
}

/**
 * @deprecated Please don't use below function, try to use BetslipError class or error mapper instead.
 */
export function getPosError(error: { type: string }): PosError {
    return POS_ERRORS[error.type] || POS_ERRORS['DEFAULT'];
}

/**
 * @deprecated please don't export or use anywhere
 */
const POS_ERRORS: { [key: string]: PosError } = {
    AccaBoostError: { icon: 'warning', range: 'platform', code: 'ABE' },
    AccaBoostBelowMinSelectionOdds: { icon: 'warning', range: 'platform', code: 'ABBMSO' },
    AccaBoostDateRangeError: { icon: 'warning', range: 'platform', code: 'ABDR' },
    AccountClosed: { icon: 'error', range: 'platform', code: 'AC' },
    BestOddsError: { icon: 'error', range: 'betslip', code: 'BOG' },
    BestOddsDateRangeError: { icon: 'error', range: 'betslip', code: 'BOGDR' },
    BetPlacementExtensionError: { icon: 'error', range: 'platform', code: 'BPEE' },
    BetTypeNotAllowed: { icon: 'warning', range: 'betslip', code: 'BTNA' },
    BetTypeNotAllowedForFreeBet: { icon: 'warning', range: 'betslip', code: 'BTNAFFB' },
    BettingOfferBonusRestrictedError: { icon: 'warning', range: 'betslip', code: 'BOBR' },
    BlockedAsInsider: { icon: 'error', range: 'pick', code: 'BAI' },
    BlockedCountry: { icon: 'error', range: 'betslip', code: 'BC' },
    RegulatoryCountryBlocked: { icon: 'error', range: 'betslip', code: 'RCB' },
    BlockedCoolOff: { icon: 'error', range: 'betslip', code: 'BCO' },
    BlockedPlayMoney: { icon: 'warning', range: 'betslip', code: 'IMZB' },
    BlockedServiceClosureByAgent: { icon: 'error', range: 'betslip', code: 'BSCBA' },
    BlockedServiceClosureByPlayer: { icon: 'error', range: 'betslip', code: 'BSCBP' },
    BlockedResponsibleGamingReasons: { icon: 'error', range: 'betslip', code: 'BRGR' },
    ChangedOptionStatus: { icon: 'warning', range: 'pick', code: 'COS', lock: 60 },
    ComboPrevention: { icon: 'warning', range: 'pick', code: 'CP' },
    CutOffDateReached: { icon: 'warning', range: 'pick', code: 'CODR', lock: 100 },
    DailyNumberOfBetLimitExceeded: { icon: 'error', range: 'betslip', code: 'DNOBLE' },
    DoubleBetPrevention: { icon: 'error', range: 'betslip', code: 'DBP' },
    DuplicatedOption: { icon: 'error', range: 'pick', code: 'DO' },
    EdsBetAndGetError: { icon: 'error', range: 'betslip', code: 'EBGE' },
    EdsBetAndGetUnderMinimumBetOddsError: { icon: 'error', range: 'betslip', code: 'EBGUMBE' },
    EdsBetAndGetUnderMinimumTotalOddsError: { icon: 'error', range: 'betslip', code: 'EBGUMTOE' },
    PromoTokenError: { icon: 'error', range: 'betslip', code: 'PTE' },
    PromoTokenMinimumBetOddsError: { icon: 'error', range: 'betslip', code: 'PTUMBOE' },
    PromoTokenUnderMinimumTotalOddsError: { icon: 'error', range: 'betslip', code: 'PTUMTOE' },
    PromoTokenOverMaximumTotalOddsError: { icon: 'error', range: 'betslip', code: 'PTOMBO' },
    PromoTokenOverMaximumBetOddsError: { icon: 'error', range: 'betslip', code: 'PTSLMO' },
    FreeBetAlreadyUsed: { icon: 'error', range: 'betslip', code: 'FBAU' },
    FreeBetExpired: { icon: 'error', range: 'betslip', code: 'FBE' },
    FreeBetNotAllowedInThisApplication: { icon: 'error', range: 'betslip', code: 'FBNAITA' },
    FreeBetNotActive: { icon: 'error', range: 'betslip', code: 'FBNA' },
    FreeBetNotMatchingLeague: { icon: 'error', range: 'betslip', code: 'FBNML' },
    FreeBetNotMatchingSport: { icon: 'error', range: 'betslip', code: 'FBNMS' },
    IdenticalBetBuilderBetsPrevention: { icon: 'warning', range: 'pick', code: 'IBBBP' },
    IncorrectBankerCount: { icon: 'error', range: 'platform', code: 'IBC' },
    IncorrectOptionCount: { icon: 'error', range: 'platform', code: 'IOC' },
    InsufficientFunMoney: { icon: 'error', range: 'betslip', code: 'IFM' },
    InsufficientMoney: { icon: 'warning', range: 'betslip', code: 'IM' },
    InsufficientBonusMoney: { icon: 'warning', range: 'betslip', code: 'IBM' },
    InsufficientBonusMoneyZeroBalance: { icon: 'warning', range: 'betslip', code: 'IBMZB' },
    InsufficientMoneyZeroBalance: { icon: 'warning', range: 'betslip', code: 'IMZB' },
    InsufficientMoneyWithTax: { icon: 'warning', range: 'betslip', code: 'IMWT' },
    InvalidBetSlipType: { icon: 'error', range: 'platform', code: 'IBT' },
    InvalidFreeBet: { icon: 'error', range: 'platform', code: 'IFB' },
    InvalidOddsAcceptance: { icon: 'error', range: 'platform', code: 'IOA' },
    InvalidCurrency: { icon: 'error', range: 'platform', code: 'IC' },
    InvalidMobileNumber: { icon: 'warning', range: 'platform', code: 'IMN' },
    InvalidOption: { icon: 'warning', range: 'pick', code: 'IO', lock: 30 },
    InvalidOrNoSignature: { icon: 'error', range: 'platform', code: 'IONS' },
    LiveMaxBetExceeded: { icon: 'error', range: 'bet', code: 'LMBE' },
    LiveMaxBetExceededNoEvent: { icon: 'error', range: 'bet', code: 'LMBENE' },
    MaximumNumberOfBetsInComboExceeded: { icon: 'warning', range: 'betslip', code: 'MNOBICE' },
    MaximumNumberOfSingleBetsExceeded: { icon: 'warning', range: 'pick', code: 'MNOSBE' },
    MaximumStakeForComboBetsExceeded: { icon: 'warning', range: 'bet', code: 'MSFCBE' },
    MaximumStakeForSingleBetsExceeded: { icon: 'warning', range: 'bet', code: 'MSFSBE' },
    OverCzUserLimit: { icon: 'warning', range: 'bet', code: 'OCZUL' },
    MaximumWinOfBetExceeded: { icon: 'warning', range: 'bet', code: 'MWOBE' },
    MaximumWinOfComboBetExceeded: { icon: 'warning', range: 'bet', code: 'MWOCBE' },
    MaxWinPerUserExceeded: { icon: 'warning', range: 'bet', code: 'MWPUE' },
    MinimumCombo: { icon: 'warning', range: 'pick', code: 'MC' },
    MissingInfo: { icon: 'warning', range: 'pick', code: 'MI', lock: 60 },
    NotAllowedInThisApplication: { icon: 'error', range: 'platform', code: 'NAITA' },
    NotPlayable: { icon: 'warning', range: 'pick', code: 'NP', lock: 90 },
    OddsChanged: { icon: 'warning', range: 'pick', code: 'OC', odds: true },
    OpenDateNotReached: { icon: 'warning', range: 'pick', code: 'ODNR', lock: 80 },
    OptionError: { icon: 'warning', range: 'pick', code: 'OE', lock: 30 },
    OptionInvisible: { icon: 'warning', range: 'pick', code: 'OI', lock: 30 },
    OutOfBusinessHours: { icon: 'warning', range: 'platform', code: 'OOBH' },
    OverallMaxWinPerUserExceeded: { icon: 'warning', range: 'bet', code: 'OMWPUE' },
    OverMaxBetLimit: { icon: 'warning', range: 'bet', code: 'OMBL' },
    OverMaxBetLimitDaily: { icon: 'warning', range: 'bet', code: 'OMBLD' },
    OverMaxBetLimitWeekly: { icon: 'warning', range: 'bet', code: 'OMBLW' },
    OverMaxBetLimitSevenDays: { icon: 'warning', range: 'bet', code: 'OMBLSD' },
    OverMaxBetLimitMonthly: { icon: 'warning', range: 'bet', code: 'OMBLM' },
    OverPersonalMaxBet: { icon: 'warning', range: 'bet', code: 'OPMB' },
    ResultClosed: { icon: 'warning', range: 'pick', code: 'RC', lock: 90 },
    ResultNotCombinable: { icon: 'warning', range: 'pick', code: 'RNC' },
    ServiceClosed: { icon: 'warning', range: 'platform', code: 'SC' },
    StakeAboveMaximumLimitWithinTimeRange: { icon: 'warning', range: 'bet', code: 'SAMLWTR' },
    GamblingControlMaxBet: { icon: 'warning', range: 'bet', code: 'GCMB' },
    OverallMaxBet: { icon: 'warning', range: 'bet', code: 'OMB' },
    StakeAboveMaximumLimit: { icon: 'warning', range: 'bet', code: 'SAML' },
    StakeBelowMinimumLimit: { icon: 'warning', range: 'bet', code: 'SBML' },
    TechnicalError: { icon: 'error', range: 'platform', code: 'TE' },
    UnderMinimumComboSize: { icon: 'warning', range: 'betslip', code: 'UMCS' },
    UnderMinimumCompulsoryOdds: { icon: 'warning', range: 'bet', code: 'UMCO' },
    UnderMinimumOdds: { icon: 'warning', range: 'pick', code: 'UMO' },
    UnderMinimumOddsLimit: { icon: 'warning', range: 'bet', code: 'UMOL' },
    UnderMinimumWinnings: { icon: 'warning', range: 'bet', code: 'UMWI' },
    Unknown: { icon: 'error', range: 'platform', code: 'UN' },
    UnexpectedError: { icon: 'error', range: 'platform', code: 'UNX' },
    UserError: { icon: 'error', range: 'platform', code: 'UE' },
    UnknownError: { icon: 'error', range: 'platform', code: 'UNE' },
    WrongCurrency: { icon: 'error', range: 'platform', code: 'WC' },
    OverMaxWinningsBoost: { icon: 'error', range: 'bet', code: 'OMWB' },
    UnderMinimumOddsBoostReward: { icon: 'error', range: 'betslip', code: 'UMOBR' },
    UnderMinimumRiskFreeCompensation: { icon: 'error', range: 'betslip', code: 'UMRFC' },
    CrmTokenError: { icon: 'error', range: 'platform', code: 'CTE' },
    InconsistentStakeTax: { icon: 'warning', range: 'betslip', code: 'INST' },
    DEFAULT: { icon: 'error', range: 'platform', code: 'UNE' },

    // Additional errors for Italy:
    BwiComboPrevention: { icon: 'warning', range: 'pick', code: 'BWICP' },
    NoMultiSinglesAllowed: { icon: 'warning', range: 'betslip', code: 'NMSA' },
    InvalidOptionId: { icon: 'warning', range: 'pick', code: 'IOID', lock: 30 },
    SystemStakeNotMultipleOfQuarter: { icon: 'warning', range: 'betslip', code: 'SSNMOQ' },
    NotWholeStake: { icon: 'warning', range: 'bet', code: 'NWS' },

    // Additional errors for UK KYC
    BlockedKyc: { icon: 'warning', range: 'betslip', code: 'UKBK' },

    // Additional error for Ontario labels
    BlockedNegativeBalance: { icon: 'error', range: 'betslip', code: 'BNB' },

    // Additional errors for US labels
    SessionLimitExceeded: { icon: 'error', range: 'betslip', code: 'SLE' },
    SessionTokenInvalid: { icon: 'error', range: 'betslip', code: 'STI' },
    CustomerBlockedInactiveError: { icon: 'error', range: 'betslip', code: 'CBIE' },

    geoLocationError: { icon: 'error', range: 'betslip', code: 'GLEVD' },

    BuyInLimitExceeded: { icon: 'error', range: 'betslip', code: 'BILE' },
    LossLimitExceeded: { icon: 'error', range: 'betslip', code: 'LLE' },
    OverMaxNewJerseyWinPoolLimit: { icon: 'error', range: 'betslip', code: 'OMNJWPL' },
    OverMaxUsWinPoolLimit: { icon: 'error', range: 'betslip', code: 'OMUSWPL' },
    LossLimitExceededDaily: { icon: 'error', range: 'betslip', code: 'LLED' },
    LossLimitExceededCalendarWeek: { icon: 'error', range: 'betslip', code: 'LLECW' },
    LossLimitExceededMonthly: { icon: 'error', range: 'betslip', code: 'LLEM' },
    LossLimitExceededDerivedMonthly: { icon: 'error', range: 'betslip', code: 'LLEDM' },
    CoolOffPeriodNotCompleted: { icon: 'error', range: 'betslip', code: 'COPNC' },

    OverAskOfferError: { icon: 'error', range: 'betslip', code: 'OAO' },

    CustomerScrubError: { icon: 'error', range: 'betslip', code: 'CSE' },
    PlayBreakNotCompleted: { icon: 'error', range: 'betslip', code: 'PBNC' },
    ParallelGamePlayPrevention: { icon: 'error', range: 'betslip', code: 'PGP' },
    PlayerNotRegisteredWithCFR: { icon: 'error', range: 'betslip', code: 'PNRWCFR' },
    UserIsSelfExcluded: { icon: 'error', range: 'betslip', code: 'USRE' },
    OasisDown: { icon: 'error', range: 'betslip', code: 'OADWN' },
    OgpBetNotAllowedInThisApplication: { icon: 'error', range: 'betslip', code: 'OBNAITA' },
};
